import React, { useRef, useState } from 'react'
import { Pane, FileCard, FileUploader, UploadIcon, Text, toaster } from 'evergreen-ui'

export function AttachFiles(props) {
    const allowedExtensions = ["dxf", "png", "jpeg", "jpg", "pdf"];
    const allowedNumOfFiles = 3;
    // drag state
    const [dragActive, setDragActive] = useState(false);
    const [progress, setProgress] = useState(0);
    // ref
    const inputRef = useRef(null);
    const btnRef = useRef(null);
    const formRef = useRef(null);
    const MAX_FILE_MSG = "You have uploaded the maximum number of attachments";




    // handle drag events
    const handleDrag = function (e) {
        if (e.dataTransfer.types.indexOf('book') >= 0 || e.dataTransfer.types.indexOf('folder') >= 0) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            formRef.current.classList.add('drop-zone');
            setDragActive(true);
        } else if (e.type === "dragleave") {
            formRef.current.classList.remove("drop-zone");
            setDragActive(false);
        }
    };


    //Validate File
    function fileCheck(file, numberOfFiles) {
        // console.log("Checking file...", allowedExtensions)
        return new Promise((res, rej) => {
            let ext = file.name.split('.').pop();
            if (allowedExtensions.indexOf((ext ?? '').toLowerCase()) >= 0 == false) {
                toaster.danger('Please reselect a file', {
                    description: <><Text>{"File must be of the following types: " + allowedExtensions.join(', ')}</Text><br /><Text>{"Uploaded filename: " + file.name}</Text></>
                });
                btnRef.current.innerHTML = 'Upload files';
                props.onChange(null)
                return rej()
            }
            // btnRef.current.innerHTML = file.name;
            return props.onChange(file, numberOfFiles).then(res)
        })
    };

    const doUploads = function (files) {
        if (files && files.length <= allowedNumOfFiles) {
            let p = [];
            for (let i = 0; i < files.length; i++) {
                let file = files.item(i);
                p.push(fileCheck(file, files.length))
            }

            Promise.all(p).then(() => {
                toaster.notify('Uploaded ' + p.length);
            })
        }else{
            toaster.danger("Sorry, you can only attach a maximum of " + allowedNumOfFiles + " files");
        }
    }

    // triggers when file is dropped
    const handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files.length > 0 && !props.maxFiles) {
            doUploads(e.dataTransfer.files);
        }else{
            toaster.danger(MAX_FILE_MSG)
        }
    };

    // triggers when file is selected with click
    const handleChange = function (e) {
        e.preventDefault();
        doUploads(e.target.files);
    };

    return (
        <form className="form-file-upload" ref={formRef} onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()} style={{ display: "flex", flexDirection: "column-reverse" }}>
            {progress > 0 && <ProgressBar completed={progress} />}
            {props.children}

            <input ref={inputRef} multiple="multiple" type="file" accept={allowedExtensions.map(v => '.' + v).join(', ')} id="input-file-upload" className="input-file-upload" onChange={handleChange}/>

            <label className={`${dragActive ? "drag-active" : ""} label-file-upload`} htmlFor="input-file-upload" onClick={(e) => {e.preventDefault()}}>
                <div>
                    <p><UploadIcon color={"#206BE1"} size={40} /></p>
                    <Text>Drag and drop your files here or </Text>
                    <Text>click here to <button className="upload-button" ref={btnRef} onClick={() => { props.maxFiles ? toaster.danger(MAX_FILE_MSG): inputRef.current.click(); }}>Upload files </button></Text>
                </div>
            </label>
            {dragActive && <div className="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>}
        </form>
    )
}
